import { Star } from "lucide-react";

// Compact 5-star / 143 reviews strip (light-theme friendly).
export default function ReviewBadge({ className = "" }) {
  return (
    <div
      data-testid="review-badge"
      className={`flex flex-col items-center justify-center gap-3 sm:flex-row sm:gap-4 ${className}`}
    >
      <div className="flex items-center gap-1.5">
        {Array.from({ length: 5 }).map((_, i) => (
          <span
            key={i}
            className="flex h-8 w-8 items-center justify-center rounded-md bg-emerald-500"
            aria-hidden="true"
          >
            <Star className="h-5 w-5 fill-white text-white" strokeWidth={0} />
          </span>
        ))}
      </div>
      <p className="text-brand-ink">
        <span className="font-bold">5-star rating</span>{" "}
        <span className="text-neutral-500">based on 143 reviews</span>
      </p>
      <span className="hidden h-5 w-px bg-neutral-300 sm:block" />
      <span className="flex items-center gap-2 font-bold text-brand-ink">
        <span className="flex h-6 w-6 items-center justify-center rounded-full bg-emerald-500">
          <Star className="h-3.5 w-3.5 fill-white text-white" strokeWidth={0} />
        </span>
        TrustCaptain
      </span>
    </div>
  );
}
